<div class="flex flex-col items-center gap-4 p-6 text-center">
    <!-- Icon -->
    @if (isError) {
        <div
            class="flex h-16 w-16 items-center justify-center rounded-full bg-red-100"
        >
            <mat-icon class="text-3xl text-red-600">error</mat-icon>
        </div>
    } @else {
        <div
            class="flex h-16 w-16 items-center justify-center rounded-full bg-amber-100"
        >
            <mat-icon class="text-3xl text-amber-600">lock_person</mat-icon>
        </div>
    }

    <!-- Title -->
    <h2 class="text-xl font-semibold text-gray-900">
        @if (isError) {
            {{ 'profileGate.errorTitle' | translate }}
        } @else {
            {{ 'profileGate.title' | translate }}
        }
    </h2>

    <!-- Description -->
    @if (isError) {
        <!-- Intro message -->
        <p class="text-sm text-gray-600">
            {{ 'profileGate.errorDesc' | translate }}
        </p>

        <!-- Admin reason in a highlighted box -->
        @if (data.errorMessage) {
            <div
                class="w-full rounded-md border border-red-200 bg-red-50 p-3 text-left"
            >
                <p class="text-sm font-medium text-red-800">
                    "{{ data.errorMessage }}"
                </p>
            </div>
        }

        <!-- Flagged fields -->
        @if (errorFieldLabels.length > 0) {
            <div class="w-full rounded-md bg-gray-50 p-3">
                <p class="mb-2 text-xs font-medium text-gray-600">
                    {{ 'profileGate.errorFieldsLabel' | translate }}
                </p>
                <div class="flex flex-wrap justify-center gap-1.5">
                    @for (field of errorFieldLabels; track field) {
                        <span
                            class="inline-flex items-center rounded-md bg-red-100 px-2 py-0.5 text-xs font-medium text-red-700"
                        >
                            {{ field }}
                        </span>
                    }
                </div>
            </div>
        }
    } @else {
        <p class="text-sm text-gray-500">
            @if (data.featureName) {
                {{
                    'profileGate.descWithFeature'
                        | translate: { feature: data.featureName }
                }}
            } @else {
                {{ 'profileGate.desc' | translate }}
            }
        </p>
    }

    <!-- Buttons -->
    <div class="mt-2 flex w-full gap-3">
        <button
            mat-stroked-button
            class="flex-1"
            (click)="cancel()"
            [attr.aria-label]="'profileGate.cancel' | translate"
        >
            {{ 'profileGate.cancel' | translate }}
        </button>
        <button
            mat-flat-button
            [color]="isError ? 'warn' : 'primary'"
            class="flex-1"
            (click)="continue()"
            [attr.aria-label]="
                isError
                    ? ('profileGate.resolveIssues' | translate)
                    : ('profileGate.continue' | translate)
            "
        >
            @if (isError) {
                {{ 'profileGate.resolveIssues' | translate }}
            } @else {
                {{ 'profileGate.continue' | translate }}
            }
        </button>
    </div>
</div>
